import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { TriangularGameState } from '../../jscaip/state/TriangularGameState';
import { SaharaMobilityHeuristic } from './SaharaMobilityHeuristic';
export class SaharaCapturedThenCapturedFreedomThenAllFreedomsHeuristic extends SaharaMobilityHeuristic {
    getMetrics(node, _config) {
        const capturedAndFreedomForZero = this.getCapturedAndFreedom(node.gameState, Player.ZERO);
        const capturedAndFreedomForOne = this.getCapturedAndFreedom(node.gameState, Player.ONE);
        const zeroFreedoms = this.rules.getBoardValuesFor(node.gameState, Player.ZERO);
        const oneFreedoms = this.rules.getBoardValuesFor(node.gameState, Player.ONE);
        // 1st criterion: having a prisonner is good
        // 2nd criterion: having that prisonner piece have less freedoms as possible
        // 3rd criterion: having yourself, the more freedoms
        return PlayerNumberTable.of([capturedAndFreedomForOne.captured ? 1 : 0, -capturedAndFreedomForOne.freedoms, ...zeroFreedoms], [capturedAndFreedomForZero.captured ? 1 : 0, -capturedAndFreedomForZero.freedoms, ...oneFreedoms]);
    }
    getCapturedAndFreedom(state, player) {
        for (const coord of state.allCoords()) {
            if (state.hasPieceBelongingTo(coord, player)) {
                if (this.countMovesToClosestAlly(state, coord) === Number.POSITIVE_INFINITY) {
                    const freedoms = TriangularGameState.getEmptyNeighbors(state.board, coord, FourStatePiece.EMPTY).length;
                    return { captured: true, freedoms };
                }
            }
        }
        return { captured: false, freedoms: 0 };
    }
}
